export const plans = [
  {
    price_id:
      process.env.REACT_APP_NODE_ENV == "local"
        ? "price_1OACnCGylBBY5VEABGmkgU40"
        : "price_1OAD8SGylBBY5VEAjEohMpwz",
    name: "Starter",
    limit: process.env.REACT_APP_NODE_ENV == "local" ? 5 : 500,
  },
  {
    price_id:
      process.env.REACT_APP_NODE_ENV == "local"
        ? "price_1OAD2TGylBBY5VEABsW4WoGg"
        : "price_1OAD8SGylBBY5VEA9WNY4ETn",
    name: "Intermediate",
    limit: process.env.REACT_APP_NODE_ENV == "local" ? 10 : 1000,
  },
  {
    price_id:
      process.env.REACT_APP_NODE_ENV == "local"
        ? "price_1OAD3aGylBBY5VEAGuGrugR0"
        : "price_1OAD8SGylBBY5VEAgccAa8T0",
    name: "Pro",
    limit: process.env.REACT_APP_NODE_ENV == "local" ? 30 : 3000,
  },
];
